import { CheckBoxCell } from '@med-fe/ui';

export const pxp_columns = [
  {
    title: 'Location number',
    dataIndex: 'locationNumber',
    key: 'action',
    width: 60,
    fixed: 'left',
  },
  {
    title: 'Location name',
    dataIndex: 'locationName',
    key: 'locationName',
    width: 60,
  },
  {
    title: 'Do Not Promote',
    dataIndex: 'doNotPromote',
    key: 'doNotPromote',
    width: 60,
    colType: 'checkbox',
    render: (value: boolean) => <CheckBoxCell value={value} />,
  },
];
